const prefix = 'REMOTE_CONFIG/';

export const SET_FETCH_REMOTE_CONFIG = `${prefix}SET_FETCH_REMOTE_CONFIG`;

export const setRemoteConfigFetched = data => ({ type: SET_FETCH_REMOTE_CONFIG, data });
